import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  Supplier,
  SupplierCreateRequest,
  SupplierCreateResponse,
  SupplierDetails,
  SupplierUpdateRequest,
  SupplierUpdateResponse
} from '@ms-organization-entities';
import {ApiClientConfig} from '../api-client-config';
import {ColumnWithLocalization} from "it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization";

import {PriorityPatchRequest} from '@primatoo-ms-organization';
import {DataProtectionGovernanceService} from '../interface/data-protection-governance-service';

@Injectable({
  providedIn: 'root'
})
export class SupplierService extends DataProtectionGovernanceService {

  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient
  ) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/suppliers/';
  }

  public getSuppliers(): Observable<Supplier[]> {
    const url = this.endpoint;
    return this.httpClient.get<Supplier[]>(url);
  }

  setPriority(id: number, request: PriorityPatchRequest): Observable<Supplier> {
    const url = `${this.endpoint}${id}/priority`;
    return this.httpClient.patch<Supplier>(url, request);
  }

  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpoint + `columns`;
    return this.httpClient.get<ColumnWithLocalization[]>(url);
  }

  // public updateUserColumns(columnsConfigurationUpsertRequest: ColumnsConfigurationUpsertRequest): Observable<void> {
  //   const url = this.endpoint + 'user-columns';
  //   return this.httpClient.post<void>(url, columnsConfigurationUpsertRequest);
  // }

  public getSupplierById(id: number): Observable<Supplier> {
    const url = this.endpoint + id + '/';
    return this.httpClient.get<Supplier>(url);
  }

  public getSupplierDetails(id: number): Observable<SupplierDetails> {
    const url = this.endpoint + id + '/details';
    return this.httpClient.get<SupplierDetails>(url);
  }

  public deleteSupplier(id: number): Observable<Supplier> {
    const url = this.endpoint + id + '/';
    return this.httpClient.delete<Supplier>(url);
  }

  public createSupplier(requestBody: SupplierCreateRequest): Observable<SupplierCreateResponse> {
    const url = this.endpoint;
    return this.httpClient.post<SupplierCreateResponse>(url, requestBody);
  }

  public updateSupplier(id: number, requestBody: SupplierUpdateRequest): Observable<SupplierUpdateResponse> {
    const url = this.endpoint + id + '/';
    return this.httpClient.put<SupplierUpdateResponse>(url, requestBody);
  }

  getEndPointV1(): string {
    return this.endpoint;
  }
}
